import * as angular from "angular";
import {IController} from "angular";
import {RoutesViewSettingsResourcesModel} from "../../../models/routes-view-settings.model";

export class RoutesViewResourcesSettingsPanelTemplateComponent implements IController {

  settings: RoutesViewSettingsResourcesModel;
  panelRef: any;

  public settingsCopy: RoutesViewSettingsResourcesModel;
  public enabledSections: {
    columns: boolean,
    load: boolean,
    capacity: boolean
  };

  $onInit() {
    this.settingsCopy = angular.copy(this.settings);
    this.enabledSections = {
      columns: true,
      load: true,
      capacity: true
    }
  }

  onChangeColumns(columnKey, isEnabled) {
    this.settingsCopy.columns[columnKey] = isEnabled;
  }

  onChangeLoad(loadKey, isEnabled) {
    this.settingsCopy.load[loadKey] = isEnabled;
  }

  onChangeCapacity(loadKey, isEnabled) {
    this.settingsCopy.capacity[loadKey] = isEnabled;
  }

  onSubmit() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Submit', this.settingsCopy);
  }

  onReset() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Reset');
  }

  onCancel() {
    this.panelRef.config.onCloseSuccess(this.panelRef, 'Cancel');
  }

}

angular
  .module('bringoz.admin.routes')
  .component('routesViewResourcesSettingsPanelTemplate', {
    bindings: {
      settings: '<',
      panelRef: '<'
    },
    template: require('./routes-view-resources-settings-panel-template.html').default,
    controller: RoutesViewResourcesSettingsPanelTemplateComponent
  });
